export const RESET_PASSWORD_PATH = "/reset-password/:code";
